import React, { useState, useEffect, useContext } from 'react';
import { useRecoilState } from 'recoil';
import {
  isEContractServiceEnabledState,
  progressFlgState,
  gmoContractIdState,
  daijinContractIdState
} from '../../GlobalState';
import {
  IconButton,
  Checkbox,
  Modal,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import { TFile } from '../../types/cloudStorage/CloudFileList';
import {
  formatDatetime,
  formatDataSize,
  checkResData
} from '../../utils/common';
import { parsePrice } from '../../utils';
import { getFileDownload } from '../../apicalls/cloudFile';
import { useHistory } from 'react-router-dom';
import { PreviewField } from './Preview';
import { PdfIcon } from '../parts/svgIcon/FileIcon';
import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@mui/icons-material/Send';
import { CustomTooltip } from '../tooltip/CustomTooltip';
import { atom } from 'recoil';
import { getDocumentStatusDocument } from '../../apicalls/cloud/cloudFile';
import { useSnackbar } from 'notistack';
import { ROLE } from '../../const/Const';
import { AuthInfoContext } from '../../AuthContextProvider';

type Tprops = {
  file: TFile;
  addSelectedFiles: (file: TFile) => void;
  removeSelectedFiles: (file: TFile) => void;
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenESignatureModal: React.Dispatch<React.SetStateAction<boolean>>;
  setFileId: React.Dispatch<React.SetStateAction<number | undefined>>;
  selectedFiles: TFile[];
  setESignatureFileId: React.Dispatch<React.SetStateAction<number | undefined>>;
  setESignatureFileName: React.Dispatch<React.SetStateAction<string>>;
  constructId: number;
};

export const econtractStatusState = atom({
  key: 'econtractStatusState',
  default: false
});

export const FileList: React.FC<Tprops> = (props: Tprops) => {
  const {
    file,
    addSelectedFiles,
    removeSelectedFiles,
    setOpenDetailModal,
    setOpenESignatureModal,
    setFileId,
    selectedFiles,
    setESignatureFileId,
    setESignatureFileName,
    constructId
  } = props;

  const [isEContractServiceEnabled, setIsEContractServiceEnabled] =
    useRecoilState<any>(isEContractServiceEnabledState);
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();
  const history = useHistory();
  // プレビュー
  const [src, setSrc] = useState<string>('');
  const [openPreview, setOpenPreview] = useState<boolean>(false);
  // ローディング
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [econtractStatus, setEcontractStatus] =
    useRecoilState(econtractStatusState);
  const [gmoStatus, setGmoStatus] = useState<string>('');
  const [daijinStatus, setDaijinStatus] = useState<number>(0);
  const [gmoContractId, setGmoChangeStatusState] =
    useRecoilState(gmoContractIdState);
  const [daijinContractId, setDaijinChangeStatusState] = useRecoilState(
    daijinContractIdState
  );
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const onDownload = async () => {
    if (!file) {
      return;
    }
    setProgressFlg(true);
    await getFileDownload(String(file.id), true).then((data: any) => {
      if (data === 'Not logged in!') {
        history.push('/');
      } else {
        if (typeof data === 'string') {
          console.log(data);
        } else {
          if (data.error) {
            console.log(data.error);
          } else {
            // 書類ダウンロード
            let bin = atob(data.data.replace(/^.*,/, ''));

            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            let fileData = new File([buffer.buffer], data.data, {
              type: data.file_format
            });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(fileData);
            const fileName = file.name;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        }
      }
      setProgressFlg(false);
    });
  };

  const PdfPreview = async () => {
    if (!file) {
      return;
    }
    setProgressFlg(true);
    await getFileDownload(String(file.id), false).then((data: any) => {
      if (data === 'Not logged in!') {
        history.push('/');
      } else {
        if (typeof data === 'string') {
          console.log(data);
        } else {
          if (data.error) {
            console.log(data.error);
          } else {
            console.log(data);

            let bin = atob(data.data.replace(/^.*,/, ''));

            let buffer = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) {
              buffer[i] = bin.charCodeAt(i);
            }

            let image_file = new File([buffer.buffer], data.data, {
              type: data.file_format
            });
            setSrc(URL.createObjectURL(image_file));
            setOpenPreview(true);
          }
        }
      }
      setProgressFlg(false);
    });
  };

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (checked) {
      // 選択ファイル追加
      addSelectedFiles(file);
    } else {
      // 選択ファイル削除
      removeSelectedFiles(file);
    }
  };

  // econtract_statusを判定
  const checkEcontractStatus = (status: string) => {
    if (status && status.trim() !== '') {
      setEcontractStatus(true);
    } else {
      setEcontractStatus(false);
    }
  };

  useEffect(() => {}, [selectedFiles]);

  useEffect(() => {
    const updateDaijinStatus = async () => {
      if (!file.daijin_contract_id && daijinContractId) {
        // 送信中ファイルに daijin_contract_id が設定されていない場合、
        // 新しい ID を設定することでステータスを即反映
        file.daijin_contract_id = daijinContractId;
        setDaijinChangeStatusState('');
      }

      if (
        authInfo?.role != ROLE['OUTSIDE_PARTNER'] &&
        isEContractServiceEnabled === 2 &&
        file.daijin_contract_id
      ) {
        try {
          const resData = await getDocumentStatusDocument(
            constructId,
            file.daijin_contract_id,
            file.id
          );
          const data = await checkResData(resData, enqueueSnackbar);
          setDaijinStatus(data.status);
        } catch (error) {
          enqueueSnackbar('Error occurred while fetching document status', {
            variant: 'error'
          });
        } finally {
          setDaijinChangeStatusState('');
        }
      }
    };

    updateDaijinStatus();
  }, [isEContractServiceEnabled, daijinContractId, file]);

  useEffect(() => {
    const updateGmoStatus = async () => {
      if (!file.gmo_contract_id && gmoContractId) {
        // 送信中ファイルに gmo_contract_id が設定されていない場合、
        // 新しい ID を設定することでステータスを即反映
        file.gmo_contract_id = gmoContractId;
        setGmoChangeStatusState('');
      }
      if (
        authInfo?.role !== ROLE['OUTSIDE_PARTNER'] &&
        isEContractServiceEnabled === 1 &&
        file.gmo_contract_id
      ) {
        try {
          const resData = await getDocumentStatusDocument(
            constructId,
            file.gmo_contract_id,
            file.id
          );
          const data = await checkResData(resData, enqueueSnackbar);
          const getStatus = data.status.find(
            (item: any) => item.envelope_xid === file.gmo_contract_id
          );
          if (getStatus) {
            setGmoStatus(getStatus.envelope_status);
          } else {
            updateGmoStatus();
          }
        } catch (error) {
          enqueueSnackbar('Error occurred while fetching document status', {
            variant: 'error'
          });
        } finally {
          setGmoChangeStatusState('');
        }
      }
    };

    updateGmoStatus();
  }, [isEContractServiceEnabled, gmoContractId, file]);

  return (
    <>
      <TableBody>
        <StyledTableRow className='click_table_row' title=''>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 10 }}
            align='center'
          >
            <Checkbox
              checked={
                selectedFiles.find(selectedFile => selectedFile.id == file.id)
                  ? true
                  : false
              }
              onChange={handleCheck}
              color='default'
            />
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 150 }}
            align='center'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {file.name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 60 }}
            align='center'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {file.file_type_name}
          </StyledTableCell>

          {authInfo?.role != ROLE['OUTSIDE_PARTNER'] &&
            isEContractServiceEnabled && (
              <StyledTableCell
                className={classes.table1}
                style={{ width: 80 }}
                align='center'
                onClick={() => {
                  setOpenDetailModal(true);
                  setFileId(file.id);
                  checkEcontractStatus(file.econtract_status);
                }}
              >
                {isEContractServiceEnabled == 1 && file.gmo_contract_id && (
                  <>
                    {(() => {
                      switch (gmoStatus) {
                        case '2':
                          return '署名待ち';
                        case '4':
                          return '署名完了';
                        case '6':
                          return '署名辞退';
                        default:
                          return '';
                      }
                    })()}
                  </>
                )}
                {isEContractServiceEnabled == 2 && file.daijin_contract_id && (
                  <>
                    {(() => {
                      switch (daijinStatus) {
                        case 2:
                          return '確定';
                        case 3:
                          return '先方確認中（送信済）';
                        case 4:
                          return '締結完了';
                        case 6:
                          return '却下';
                        default:
                          return '';
                      }
                    })()}
                  </>
                )}
              </StyledTableCell>
            )}

          <StyledTableCell
            className={classes.table1}
            style={{ width: 80 }}
            align='center'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {file.send_to_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 80 }}
            align='right'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {file.receive_from_name}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 70 }}
            align='right'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {parsePrice(file.amount)}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 50 }}
            align='right'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {formatDataSize(file.size)}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 90 }}
            align='right'
            onClick={() => {
              setOpenDetailModal(true);
              setFileId(file.id);
              checkEcontractStatus(file.econtract_status);
            }}
          >
            {formatDatetime(new Date(file.exchange_date), 'YYYY年MM月DD日')}
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 30 }}
            align='center'
          >
            <CustomTooltip title={'ダウンロード'} placement='top'>
              <IconButton onClick={onDownload} className={classes.button}>
                <GetAppIcon />
              </IconButton>
            </CustomTooltip>
          </StyledTableCell>
          <StyledTableCell
            className={classes.table1}
            style={{ width: 30 }}
            align='center'
          >
            {file.format == 'application/pdf' && (
              <CustomTooltip title={'PDFプレビュー'} placement='top'>
                <IconButton onClick={PdfPreview} className={classes.button}>
                  <PdfIcon width={21} height={26} />
                </IconButton>
              </CustomTooltip>
            )}
          </StyledTableCell>
          {authInfo?.role !== ROLE['OUTSIDE_PARTNER'] &&
          authInfo?.user_id === file.created_by ? (
            <StyledTableCell
              className={classes.table1}
              style={{ width: 30 }}
              align='center'
            >
              {isEContractServiceEnabled && file.format === 'application/pdf' && (
                <CustomTooltip title={'電子契約'} placement='top'>
                  <IconButton
                    onClick={() => {
                      setESignatureFileId(file.id);
                      setESignatureFileName(file.name);
                      setOpenESignatureModal(true);
                    }}
                    className={classes.button}
                  >
                    <SendIcon />
                  </IconButton>
                </CustomTooltip>
              )}
            </StyledTableCell>
          ) : (
            <StyledTableCell
              className={classes.table1}
              style={{ width: 30 }}
              align='center'
            ></StyledTableCell>
          )}
        </StyledTableRow>
      </TableBody>

      {/* プレビュー */}
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}
        open={openPreview}
        onClose={() => setOpenPreview(false)}
      >
        <PreviewField
          src={src}
          openPreview={openPreview}
          setOpenPreview={setOpenPreview}
        />
      </Modal>
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#999999 !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold'
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8,
      wordBreak: 'break-all'
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    },
    modal: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    searchBtn: {
      marginBottom: 10,
      marginRight: 20,
      marginLeft: 20,
      backgroundColor: '#52555F'
    },
    button: {
      backgroundColor: '#f5f5f5',
      boxShadow:
        '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)'
    }
  })
);

// スタイル関係
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);
